const html = require('choo/html');
const Component = require('choo/component');
const { nanohtmlCreatesDomNodes } = require('./nanohtmlEnv');
const { buildKunqiongFooterHtml } = require('../../common/kunqiongChromeHtml');
const { SEND_UI_LANGUAGES } = require('./sendLanguageOptions');

class Footer extends Component {
  constructor(name, state, emit) {
    super(name);
    this.state = state;
    this.emit = emit;
  }

  update() {
    if (this.locale !== this.state.locale) {
      this.locale = this.state.locale;
      return true;
    }
    return false;
  }

  setLanguage(ev, code) {
    ev.preventDefault();
    ev.stopPropagation();
    this.emit('setLanguage', code);
  }

  renderLangList() {
    const currentLang = this.state.locale;
    const translate = this.state.translate;
    return html`
      <section
        class="send-footer-languages w-full border-t border-b border-grey-20 dark:border-grey-70 bg-grey-10 dark:bg-grey-90"
        aria-label="${translate('langSwitchTitle')}"
      >
        <div
          class="max-w-6xl mx-auto px-4 py-6 w-full text-center"
        >
          <h2
            class="text-xs font-medium text-grey-60 dark:text-grey-50 uppercase tracking-widest mb-3"
          >
            ${translate('kqFooterLangHeading')}
          </h2>
          <nav
            class="flex flex-wrap items-baseline justify-center text-sm leading-relaxed"
            aria-label="${translate('langSwitchTitle')}"
          >
            ${SEND_UI_LANGUAGES.map((lang, i) => html`
              ${i > 0
                ? html`
                    <span
                      class="text-grey-40 dark:text-grey-55 mx-2 select-none shrink-0"
                      aria-hidden="true"
                    >|</span>
                  `
                : ''}
              <button
                type="button"
                class="inline bg-transparent border-0 p-0 m-0 cursor-pointer font-normal transition-colors duration-150 focus:outline-none rounded-sm ${currentLang === lang.code ? 'text-blue-60 font-medium' : 'text-grey-70 dark:text-grey-40 hover:text-blue-60'}"
                onclick="${e => this.setLanguage(e, lang.code)}"
              >
                ${lang.label}
              </button>
            `)}
          </nav>
        </div>
      </section>
    `;
  }

  createElement() {
    const t = id => this.state.translate(id);
    const kunqiongFooterMarkup = buildKunqiongFooterHtml(t);

    if (nanohtmlCreatesDomNodes()) {
      const wrap = html`
        <div class="kq-chrome-footer w-full flex-none flex flex-col">
          ${this.renderLangList()}
          <div class="kq-footer-slot"></div>
        </div>
      `;
      const slots = wrap.getElementsByClassName('kq-footer-slot');
      const slot = slots[0];
      if (slot) {
        slot.innerHTML = kunqiongFooterMarkup;
      }
      return wrap;
    }

    return html`
      <div class="kq-chrome-footer w-full flex-none flex flex-col">
        ${this.renderLangList()}
        <div class="kq-footer-slot">${{ outerHTML: kunqiongFooterMarkup }}</div>
      </div>
    `;
  }
}

module.exports = Footer;
